import React from 'react';

const Staff = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Our Team
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures is powered by a team of experienced professionals with deep expertise across strategic investments, management consultancy, and diverse industry sectors.
            </p>

            {/* Leadership Section */}
            <h2 className="text-2xl font-bold text-primary mb-6">Leadership</h2>
            
            {/* CEO - Mayoor Shastry BN */}
            <div className="bg-white border-2 gold-border rounded-lg p-8 mb-8">
              <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6">
                <img 
                  src="/ceo-photo.jpg" 
                  alt="Mayoor Shastry BN - CEO" 
                  className="w-48 h-48 rounded-lg object-cover shadow-lg border-4 gold-border"
                />
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-primary mb-2">Mayoor Shastry BN</h3>
                  <p className="gold-text font-semibold text-lg mb-4">Chief Executive Officer</p>
                  
                  <div className="mb-4">
                    <h4 className="font-semibold text-primary mb-2">Education</h4>
                    <ul className="text-gray-700 space-y-1">
                      <li>• B.Tech in Mechanical Engineering</li>
                      <li>• MBA in Information Technology and Systems Management</li>
                    </ul>
                  </div>
                  
                  <div className="mb-4">
                    <h4 className="font-semibold text-primary mb-2">Experience</h4>
                    <p className="text-gray-700">
                      Business Analyst with 4+ years of professional experience
                    </p>
                  </div>
                  
                  <p className="text-gray-700 leading-relaxed">
                    As CEO of Vajreya Ventures Private Limited, Mayoor Shastry BN leads the company's strategic vision and operations. With extensive experience in strategic investments and management consultancy, he has established Vajreya Ventures as a trusted partner for businesses seeking growth and financial excellence across multiple sectors.
                  </p>
                </div>
              </div>
            </div>

            {/* Managing Director - Nagaraja R Shastry */}
            <div className="bg-white border-2 gold-border rounded-lg p-8 mb-8">
              <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6">
                <img 
                  src="/nagaraja-photo.jpg" 
                  alt="Nagaraja R Shastry - Managing Director" 
                  className="w-48 h-48 rounded-lg object-cover shadow-lg border-4 gold-border"
                />
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-primary mb-2">Nagaraja R Shastry</h3>
                  <p className="gold-text font-semibold text-lg mb-4">Managing Director</p>
                  
                  <div className="mb-4">
                    <h4 className="font-semibold text-primary mb-2">Experience</h4>
                    <ul className="text-gray-700 space-y-1">
                      <li>• 25+ years of experience in the I.T sector</li>
                      <li>• Successfully headed 375+ projects</li>
                    </ul>
                  </div>
                  
                  <p className="text-gray-700 leading-relaxed">
                    With over 25 years of distinguished experience in the Information Technology sector, Nagaraja R Shastry brings exceptional leadership and technical expertise to Vajreya Ventures. Having successfully headed more than 375 projects throughout his career, he provides strategic direction and operational excellence across the organization's diverse portfolio.
                  </p>
                </div>
              </div>
            </div>

            {/* Team Expertise Section */}
            <h2 className="text-2xl font-bold text-primary mb-6">Our Team's Expertise</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Strategic Investments</h3>
                <p className="text-gray-700">
                  Our investment professionals bring decades of combined experience in strategic investments, mergers and acquisitions, securities trading, and financial advisory services.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Management Consultancy</h3>
                <p className="text-gray-700">
                  Our consultants specialize in business strategy, operations optimization, organizational development, and change management across diverse industries.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Real Estate</h3>
                <p className="text-gray-700">
                  Our real estate team includes experts in property acquisition, development, valuation, and asset management with deep knowledge of domestic and international markets.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Hospitality & Media</h3>
                <p className="text-gray-700">
                  Industry veterans with proven track records in hotel management, content strategy, digital transformation, and brand development.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Research & Analysis</h3>
                <p className="text-gray-700">
                  Our research team comprises economists, analysts, and industry specialists who provide in-depth market intelligence and investment insights.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Legal & Compliance</h3>
                <p className="text-gray-700">
                  Legal experts ensuring regulatory compliance, contract negotiation, and risk management across all our operations and client engagements.
                </p>
              </div>
            </div>

            {/* Values Section */}
            <h2 className="text-2xl font-bold text-primary mb-6">Our Team Values</h2>
            
            <div className="space-y-4 mb-8">
              <div className="bg-white border-l-4 border-gold p-6">
                <h3 className="text-lg font-bold text-primary mb-2">Excellence</h3>
                <p className="text-gray-700">We are committed to delivering the highest quality of service in everything we do, continuously improving our skills and knowledge.</p>
              </div>

              <div className="bg-white border-l-4 border-gold p-6">
                <h3 className="text-lg font-bold text-primary mb-2">Integrity</h3>
                <p className="text-gray-700">We uphold the highest ethical standards and maintain transparency in all our professional relationships and transactions.</p>
              </div>

              <div className="bg-white border-l-4 border-gold p-6">
                <h3 className="text-lg font-bold text-primary mb-2">Collaboration</h3>
                <p className="text-gray-700">We work as a unified team, leveraging diverse expertise and perspectives to deliver comprehensive solutions to our clients.</p>
              </div>

              <div className="bg-white border-l-4 border-gold p-6">
                <h3 className="text-lg font-bold text-primary mb-2">Innovation</h3>
                <p className="text-gray-700">We embrace new ideas and approaches, staying ahead of industry trends to provide cutting-edge solutions and insights.</p>
              </div>
            </div>

            {/* Career Section */}
            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Join Our Team</h3>
              <p className="mb-6">
                We are always looking for talented professionals to join Vajreya Ventures. If you're passionate about excellence and want to be part of a dynamic team, we'd love to hear from you.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Contact Us for Career Opportunities
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Staff;
